export default __webpack_public_path__ + "static/media/arena_6.2c34734c.jpeg";